import React from 'react';
import { Button } from '../ui/Button';

interface FeatureSectionProps {
  title: string;
  description: string;
  features: string[];
  ctaText: string;
  onCtaClick: () => void;
}

export function FeatureSection({ 
  title, 
  description, 
  features, 
  ctaText, 
  onCtaClick 
}: FeatureSectionProps) {
  return (
    <div className="py-8">
      <h3 className="text-2xl font-bold mb-4">{title}</h3>
      <p className="mb-4 text-gray-700">{description}</p>
      <ul className="space-y-2 mb-6">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center gap-2">
            <span className="text-2xl">{feature.split(' ')[0]}</span>
            <span>{feature.split(' ').slice(1).join(' ')}</span>
          </li>
        ))}
      </ul>
      <div className="text-center">
        <Button onClick={onCtaClick}>{ctaText}</Button>
      </div>
    </div>
  );
}